<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'financial-finDetail-travelExpense',
  components: { PageTable },
}
</script>
